function dropdownOptions(p) {
  return p
    .map((option) => {
      return {
        ...option,
        id: String(option.id),
        value: String(option.id),
        name: String(option.name),
        label: String(option.name),
        code: option.code ? String(option.code) : "",
        serial_number: option.serial_number ? String(option.serial_number) : "",
      };
    })
    .sort((previous, current) => {
      if (previous.name > current.name) {
        return 1;
      } else {
        return -1;
      }
    });
}

// input -> 2022-05-15T20:00:00.000Z
// output -> 15 May 2022
function generateDate(date) {
  if (!date) {
    return;
  }

  const options = { day: "2-digit", month: "short", year: "numeric" };
  return new Date(date).toLocaleDateString("en-GB", options).replace(",", "");
}

function generateDateTime(date) {
  if (!date) {
    return;
  }
  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };
  return date
    .toLocaleDateString("en-GB", options)
    .replace(",", "")
    .replace(/,|:|\s/g, "-");
}
// Downloads a capture by creating a virtual link with specified file name and data URL.
function downloadCapture(fileName, dataURL) {
  /*
  Downloads a capture by creating a virtual link with specified file name and data URL.
  @params {string} - The desired file name
  @params{string} - The dataURL
  */
  // Split the data URL to extract the MIME type and the actual data
  const hrefSplit = dataURL.split(",");
  // Create a virtual link element
  const virtualLink = document.createElement("a");
  // Set the download attribute of the link to the encoded file name
  virtualLink.setAttribute("download", encodeURIComponent(fileName));
  // Set the href attribute of the link to the modified data URL
  virtualLink.setAttribute(
    "href",
    hrefSplit[0] + "," + encodeURIComponent(hrefSplit[1])
  );
  // Simulate a click event on the virtual link to trigger the file download
  virtualLink.click();
}

/*
  Downloads a Workbook onto excel desired information passed through sheets
  @params {array[objects]} -  sheets
  @params {string} - fileName
  */
function downloadToExcel(fileName, sheets, headerMappings = null) {
  const workbook = XLSX.utils.book_new();

  for (const sheet of sheets) {
    let transformedContent;

    if (headerMappings && Object.keys(headerMappings).length > 0) {
      transformedContent = sheet.content.map((row) =>
        Object.fromEntries(
          Object.entries(row).map(([key, value]) => [
            headerMappings[key] || key,
            value,
          ])
        )
      );
    } else {
      transformedContent = sheet.content;
    }

    let content = XLSX.utils.json_to_sheet(transformedContent);
    XLSX.utils.book_append_sheet(workbook, content, sheet.name);
  }

  // Generate the Excel file
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  // Convert the buffer to a Blob
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  fileName = `${fileName} ${generateDateTime(new Date())}.xlsx`;
  // Save the Blob as an Excel file
  saveAs(blob, fileName);
}

// checks value of data passed through so that it isn't blank or makes an error in the worksheet
function checkValue(value, type) {
  if (type === "DATE" && value) {
    // if value isn't null and it's a date
    return generateDate(value);
  }
  if (type === "BOOLEAN") {
    // if value is true and is a Boolean
    if (value) {
      return "True";
    }
    // if value is false (but isn't null) and is a Boolean
    else if (value === false) {
      return "False";
    }
  }
  // if value is null
  return value ? value : "N/A";
}

/**
 @param {string} - The table referenced in current RMPage
 @param {object} - Object containing rows of all information in table referenced in current RMPage
 @return {object} - Object containing rows where keys are in standard english, and have important keys at the beginning
 Called from RMPage, maps each piece of information into standard english, as well as removing any information not wanted in excel spreadsheet
  */
function attributeMapper(rows, meta) {
  // array of rows which aren't wanted in the worksheet
  const exclusionList = [
    "account_id",
    "account_group_id",
    "created_at",
    "created_by_id",
    "created_by",
    "client_logo",
    "comments",
    "high_band_id",
    "id",
    "import_session_id",
    "industry_id",
    "deleted_at",
    // "is_onboard",
    "jrs_id",
    "low_band_id",
    "profile_picture",
    "project_id",
    "sector_id",
    "status_id",
    "type_id",
    "tsc_box_url",
    "updated_at",
    "updated_by_id",
    "updated_by",
    "user_id",
  ];

  // maps the rows passed through to a new object, which excluded unwanted rows
  return rows.map((object) => {
    const newObject = {};

    for (const key in object) {
      if (exclusionList.includes(key)) {
        delete object[key];
        continue;
      }
    }

    for (const entry of meta) {
      if (entry.path in object) {
        newObject[entry.displayName] = checkValue(
          object[entry.path],
          entry.type
        );
      }
    }

    return newObject;
  });
}

/**
 * @param {*} filteredColumns
 *
 * Function that orders columns specifically for the download all option depending on the
 * metadata file for the datatable from where the data is downloaded
 *
 * To order the columns for the download the downloadOrder key must be added in the meta file
 * This will allow you to rank the columns to be ordered.
 * The first column will need to have the largest number like 10
 * For the columns that the order does not matter for, there is no need to add a downloadOrder
 */
function orderingColumns(col) {
  return col.sort((a, b) => {
    // Extract downloadOrder values from each object
    const orderA = a.downloadOrder || -100; // default to 0 if downloadOrder is undefined
    const orderB = b.downloadOrder || -100;

    // Compare downloadOrder values
    if (orderA > orderB) {
      return -1;
    }
    if (orderA < orderB) {
      return 1;
    }
    return 0;
  });
}

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export {
  dropdownOptions,
  generateDate,
  generateDateTime,
  downloadCapture,
  downloadToExcel,
  attributeMapper,
  orderingColumns,
};
